<template>
	<a 
		class="position-fixed d-flex align-items-center justify-content-center rounded-circle text-white shadow transition-all"
		target="_blank" style="width: 55px; height: 55px; z-index: 9999; background-color: #25D366" 
		aria-label="Enviar mensaje por Whatsapp" 
		:href="waLink">
    <IcoWhatsapp class="bi bi-whatsapp" style="width: 36px; height: 36px;" />
	</a>
</template>

<script setup>
import IcoWhatsapp from '@/components/common/icons/IcoWhatsapp.vue'
const waLink = `https://wa.me/34655526534?text=Hola, me gustaría solicitar algo de información. ¿Puedes ayudarme?`
</script>

<style scoped>
.position-fixed {
	bottom: 0.8rem;
	right: 0.8rem;
}

@media (max-width: 767.98px) {
	.position-fixed {
		bottom: 3.2em!important;
	}
}
</style>